<!-- Route Component -->

<template>
<div class="ac-route">
    <div class="route-header">
        <b-collapse aria-id="podHeader" :open="true">
            <div class="toggle-filter" slot="trigger" role="button" aria-controls="podHeader">
                <div class="route-header-title">
                    {{route.name}}&nbsp;
                    <b-tooltip :label="$t('Route.editroute_tooltip')" type="is-secondary" position="is-bottom">
                        <b-icon class="is-secondary" icon="pencil" @click.native="edit()"></b-icon>
                    </b-tooltip>
                </div>
            </div>

            <div class="route-header-info" v-if="route.driverName && route.driverName != null">
                <b-icon icon="truck-delivery" type="is-secondary" /> {{$t('Route.driver')}}
                <b>{{route.driverName}}</b>
            </div>
            <div class="route-header-info" v-if="route.vehicle && route.vehicle.trolleyCapacity">
                <b-icon icon="cart" type="is-secondary" />
                <b>{{route.vehicle.trolleyCapacity}}</b> {{$t('Route.trolley')}}
            </div>
            <div class="route-header-info" v-if="route.departureHour != null">
                <b-icon icon="clock" type="is-secondary" /> {{$t('Route.departure_time')}}
                <b>{{formatHour(route.departureHour)}}</b>
            </div>
        </b-collapse>
    </div>
    <div class="route-body">
        <draggable class="dropzone" v-model="podsList" group="pod">
            <Pod v-for="(pod, index) in podsList"
                 :key="index"
                 :podId="pod.id"
                 :planningId="planningId"
                 :routeId="route.id"/>
        </draggable>
    </div>
</div>
</template>

<script>
/* eslint-disable no-console */
import draggable from 'vuedraggable'
import Pod from './Pod.vue'
import moment from 'moment'
import RouteModal from './RouteModal.vue'

export default {
  name: 'Route',
  props: {
    planningId: {
      type: Number,
      required: true
    },
    route: {
      type: Object,
      required: false
    }
  },

  components: {
    draggable,
    Pod
  },

  methods: {

    /**
         * Departure hour / 60 must be between 0 and 24
         */
    formatHour (departureHour) {
      if (departureHour != null) {
        const hours = departureHour / 60
        const minutes = departureHour % 60

        return moment(hours + ' ' + minutes, 'HH mm').format(
          'LT'
        )
      }
      return null
    },

    edit () {
      this.$buefy.modal.open({
        parent: this,
        component: RouteModal,
        props: {
          planningId: this.planningId,
          route: this.route,
          action: 'EDIT'
        }
      })
    }
  },

  data () {
    return {}
  },

  computed: {
    podsList: {
      get () {
        // Sort by order
        const podsOfRoute = JSON.parse(JSON.stringify(this.$store.getters['planning/filteredroutepods'](this.planningId)(this.route.id))).sort((a, b) => {
          if (a.order != null && b.order != null) {
            return a.order > b.order ? 1 : -1
          }
          if (a.order != null && b.order == null) {
            return 1
          }
          if (a.order == null && b.order != null) {
            return -1
          }
        })
        return podsOfRoute
      },
      set (pods) {
        // Set order
        let allPods = JSON.parse(JSON.stringify(pods)).map(function (item, index) {
          item.order = index
          return item
        })

        // If we are filtering pods, we need to retrieve all the pods to avoid deleting them
        if (this.$store.getters['planning/isRouteFiltering']) {
          allPods = allPods.concat(this.$store.getters['planning/routepods'](this.planningId)(this.route.id))
        }

        // Group by site code and merge pod
        const podsMerged = []
        const results = new Map()
        allPods.forEach(pod => {
          if (results.has(pod.site.code)) {
            const mergedPod = results.get(pod.site.code)
            for (let i = 0; i < mergedPod.days.length; i++) {
              mergedPod.days[i] = mergedPod.days[i] || pod.days[i]
            }
            results.set(pod.site.code, mergedPod)
          } else {
            results.set(pod.site.code, pod)
          }
        })
        results.forEach((value) => {
          podsMerged.push(value)
        })

        // Call action to modify store
        this.$store.dispatch('planning/addPodsToRoute', [this.planningId, this.route.id, podsMerged])
      }
    }
  }
}
</script>

<style lang="scss">
.ac-route {
    height: max-content;
    min-height: 100%;
    flex: 0 0 250px;
    border-width: 1px;
    border-color: #ac936c;
    border-style: solid;
    background-color: white;
    margin: 0 5px 0 5px;

    .dropzone {
        height: 100%;
    }

    .route-header {
        border-bottom-width: 2px;
        border-bottom-color: #ac936c;
        border-bottom-style: solid;
    }

    .route-header-title {
        background-color: #448993;
        color: white;
        text-align: center;
        font-size: 1.5rem;
        border-width: 2px;
    }

    .route-header-info {
        padding-left: 20px;
    }

    .route-header-info .icon {
        margin-right: 10px;
    }

    .route-body {
        min-height: 100%;
        text-align: center;
    }

    .is-day-actif {
        cursor: pointer;
    }
}

</style>
